import React, { FC } from 'react'
import { cn } from '../../../shared/utils'

import styles from '../Story.module.scss'
import { Icon } from '@wmgtech/legato'
import { useStoryContext } from '../StoryContext'

type TSharedBookmarkProps = {
  text?: string
}

export const SharedBookmark: FC<TSharedBookmarkProps> = (props) => {
  const story = useStoryContext()
  const isShared = story.review_status !== null
  const isGlobal = story.global_status === 'PUBLISHED'
  return isShared ? (
    <div className={cn(styles.sharedBookmark, {
      [styles.isGlobal]: isGlobal
    })}>
      <Icon name={'share-nodes'} />
      {isGlobal ? (
        <span>Shared Success Story</span>
      ) : (
        <span>Shared with Repertoire Owner</span>
      )}
    </div>
  ) : null
}
